const config = {
    // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
    // like '/berry-material-react/react/default'
    basename: '',
    defaultPath: '/dashboard/default',
    company: 'https://www.cardio-id.com/',
    fontFamily: `'Rubik', Medium`,
    borderRadius: 12,
    il8n: 'pt' // 'en' - English, 'pt' - Portuguese
};

export default config;
